<template>
  <!-- start section -->
  <section class="section section--dark-bg">
    <div class="container">
      <div class="section-heading section-heading--center section-heading--white">
        <h2 class="__title">Nuestro <span>contacto</span></h2>

        <p>Calle Industrial 4, lote 44B, La Primavera, C.P. 80300 Culiacán Sin. México Tel. +52 (667) 760-37-50 y 40 ventas@agrobiosol.com.mx</p>
      </div>

      <form class="contact-form js-contact-form" action="#" autocomplete="off">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="input-wrp">
              <input 
                class="textfield" 
                name="name" 
                type="text" 
                placeholder="Nombre"
                v-model="name" />
            </div>
            <p v-if="formErrors.name" class="form-error">{{ formErrorsMessage.name }}</p>
          </div>

          <div class="col-12 col-md-6">
            <div class="input-wrp">
              <input 
                class="textfield" 
                name="email" 
                type="text" 
                placeholder="E-mail"
                v-model="email" />
            </div>
            <p v-if="formErrors.email" class="form-error">{{ formErrorsMessage.email }}</p>
          </div>
        </div>

        <div class="input-wrp">
          <textarea 
            class="textfield" 
            name="message" 
            placeholder="Comentarios"
            v-model="message"></textarea>
          <p v-if="formErrors.message" class="form-error">{{ formErrorsMessage.message }}</p>
        </div>
        
        <button class="custom-btn custom-btn--medium custom-btn--style-3 wide" style="margin-top:40px;" role="button" @click.prevent="sendMessage">Enviar</button>

        <p style="color:#fff;">{{ res }}</p>

        <div class="form__note"></div>
      </form>
    </div>
  </section>
  <!-- end section -->
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      name: '',
      email: '',
      message: '',
      formErrors: {
        name: false,
        email: false,
        message: false
      },
      formErrorsMessage: {
        name: '',
        email: '',
        message: ''
      },
      res: ''
    }
  },
  methods: {
    sendMessage () {
      let vm = this

      let message = {
        name: this.name,
        email: this.email,
        message: this.message
      }

      if (this.name === '') {
        this.formErrors.name = true
        this.formErrorsMessage.name = 'Ingresa tu nombre'
      } else if (this.name.length <= 3) {
        this.formErrors.name = true
        this.formErrorsMessage.name = 'Ingresa tu nombre con minimo 3 caracteres'
      } else {
        this.formErrors.name = false
        this.formErrorsMessage.name = ''
      }

      if (this.email === '') {
        this.formErrors.email = true
        this.formErrorsMessage.email = 'Ingresa tu email'
      } else if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
        this.formErrors.email = true
        this.formErrorsMessage.email = 'Ingresa tu email con formato correcto'
      } else {
        this.formErrors.email = false
        this.formErrorsMessage.email = ''
      }

      if (this.message === '') {
        this.formErrors.message = true
        this.formErrorsMessage.message = 'Ingresa un mensaje'
      } else if (this.message.length >= 255) {
        this.formErrors.message = true
        this.formErrorsMessage.message = 'Ingresa un mensaje con maximo 255 caracteres'
      } else {
        this.formErrors.message = false
        this.formErrorsMessage.message = ''
      }

      let errors = Object.values(this.formErrors)
      let formValidError = errors.includes(true)

      if (!formValidError) {
        axios.post('http://s5.esoft.com.mx:45201/user/requestInfo', message)
          .then(res => {
            vm.res = 'Su mensaje a sido enviado... gracias.'
            setTimeout(function () { vm.res = '' }, 6000)
          })
          .catch(err => console.log(err))
      }
    }
  }
};
</script>

<style scoped>
.form-error {
  color: red;
}
</style>